import { isEqual } from 'lodash';
import { useMemo } from 'react';

import { ESignatureIntegration } from '../../types';

interface UseIntegrationStateParams {
  integrationDraft?: ESignatureIntegration;
  esignatureIntegration?: ESignatureIntegration;
  activeEsignatureIntegrationCount: number;
}

interface IntegrationState {
  isUnchanged: boolean;
  isActive: boolean;
  isRealIntegration: boolean;
  hasError: boolean;
  isDisabled: boolean;
}

export const useIntegrationState = ({
  integrationDraft,
  esignatureIntegration,
  activeEsignatureIntegrationCount,
}: UseIntegrationStateParams): IntegrationState => {
  return useMemo(() => {
    const isUnchanged = isEqual(integrationDraft, esignatureIntegration);
    const isActive = !!esignatureIntegration?.isActive;
    const isRealIntegration = !esignatureIntegration?.id?.startsWith('mock-');

    const hasError =
      isRealIntegration &&
      esignatureIntegration?.integrationType === 'company' &&
      (!!esignatureIntegration?.error || !isActive);

    const isDisabled =
      activeEsignatureIntegrationCount > 0 && !isRealIntegration;

    return {
      isUnchanged,
      isActive,
      isRealIntegration,
      hasError,
      isDisabled,
    };
  }, [
    integrationDraft,
    esignatureIntegration,
    activeEsignatureIntegrationCount,
  ]);
};
